import { SagaIterator } from 'redux-saga';
import { put } from 'redux-saga/effects';
import { KEY_PHRASE_SYNONYMS_RESET_ACTIONS } from 'src/react/keyPhraseSynonyms/actions/KeyPhraseSynonymsResetActions';

export function* keyPhraseSynonymsResetSaga(): SagaIterator {
    yield put(KEY_PHRASE_SYNONYMS_RESET_ACTIONS.success());
}
